module.exports = __webpack_public_path__ + "static/doggify-invoice-ecf18f0428ca74393b098b960e24b31c.png";